export function getStore(state: any) {
  return state.v2;
}
